import React from "react";
import classNames from "classnames";

import classes from "./classes.module.scss";

export enum EBadgeColor {
	INFO = "info",
	SUCCESS = "success",
	WARNING = "warning",
	ERROR = "error",
	NEUTRAL = "neutral",
}

type IProps = {
	icon: React.ReactNode;
	color: EBadgeColor;
};

export default function BadgeIcon(props: IProps): React.ReactElement {
	const { icon, color } = props;

	return <div className={classNames(classes["root"], classes[color])}>{icon}</div>;
}
